import { render, staticRenderFns } from "./PositiveChart.vue?vue&type=template&id=45a2a8aa&"
import script from "./PositiveChart.vue?vue&type=script&lang=js&"
export * from "./PositiveChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports